import { RootState } from "@/store/types";
import { Module } from "vuex";
import { OutreachState } from "./types";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
const outreach: Module<OutreachState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
export default outreach;
